import React from 'react';

import Swoop from '../swoop/swoop';

const SalesLoader = () => (
  <div aria-hidden className="sales-loader-v2">
    <Swoop
      className="sales-loader-v2__swoop"
      preserveAspectRatio="xMidYMid meet"
      viewBox="-400 -230 2500 1840"
    />
  </div>
);

export default SalesLoader;
